import Axios from "axios";
import {
    SET_CUSTOMER_TYPE_LIST,
    UNSET_CUSTOMER_TYPE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateCustomerType, getCustomerTypeList } from "@/store/api";
// initial state
const state = {
  getCustomerTypeList: [],
};

const getters = {
  getCustomerTypeList(state) {
    return state.getCustomerTypeList;
  },
};
const mutations = {
  [SET_CUSTOMER_TYPE_LIST](state, data) {
    state.getCustomerTypeList = data;
  },
  [UNSET_CUSTOMER_TYPE_LIST](state) {
    state.getCustomerTypeList = [];
  },
};

const actions = {

  saveUpdateCustomerType({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateCustomerType, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getCustomerTypeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCustomerTypeList, data)
        .then(function (response) {
          commit('SET_CUSTOMER_TYPE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_CUSTOMER_TYPE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
